import { observer } from 'mobx-react';
import * as React from 'react';
import { Format } from 'nomst/Stores/Utility/format';
import { Range } from 'nomst/Stores/Decision/range';
import CompViewHelper from 'sharedLogic/compViewHelper';
import RangePenetrationChart from 'components/Charts/rangePenetrationChart';
import './rangePenetration.scss';

interface IRangePenetrationProps {
    payRange: Range;
    payAmount: number;
    format: Format;
    className: string;
    chartClassName: string;
    useCompactPayRange: boolean;
    barHeight: number;
    pointerHeight: number;
}

@observer
export default class RangePenetration extends React.Component<IRangePenetrationProps> {
    public render(): React.ReactNode {
        const { chartClassName, payAmount, payRange, format } = this.props;
        return (
            <div className="nomst-range-penetration">
                <div className="nomst-range-penetration__range-slider">
                    <div className={`nomst-range-penetration__chart-and-range ${chartClassName}`}>
                        {this.renderRangeChart()}
                        {this.renderRangeText()}
                    </div>
                    <div
                        className="nomst-range-penetration__range-percentage"
                        data-mf-replace-inner="***"
                    >
                        {CompViewHelper.getRangePenetration(payRange, payAmount, format)}
                    </div>
                </div>
            </div>
        );
    }

    private renderRangeChart(): React.ReactNode {
        const { payRange, payAmount } = this.props;
        return (
            <RangePenetrationChart
                min={payRange.minRange}
                max={payRange.maxRange}
                pay={payAmount}
            />
        );
    }

    private renderRangeText(): React.ReactNode {
        const { useCompactPayRange } = this.props;
        const rangeTextClasses = useCompactPayRange ?
            'nomst-range-penetration__range-text nomst-range-penetration__range-text--compact'
            : 'nomst-range-penetration__range-text';

        return (
            <div className={rangeTextClasses}>
                <span>{this.rangeMinText}</span>
                <span className="nomst-range-penetration__range-divider">-</span>
                <span>{this.rangeMaxText}</span>
            </div>
        );
    }

    private get rangeMinText(): string {
        const { payRange } = this.props;
        return this.getRangeText(payRange.convertedMinRange);
    }

    private get rangeMaxText(): string {
        const { payRange } = this.props;
        return this.getRangeText(payRange.convertedMaxRange);
    }

    private getRangeText(value: number): string {
        const { payRange, format, useCompactPayRange } = this.props;
        if (useCompactPayRange) {
            return format.formatCurrencyValueAbbreviated(
                payRange.currentIsoCurrencyCode,
                value,
                payRange.isHourly);
        }

        return format.formatCurrencyValue(
            payRange.currentIsoCurrencyCode,
            value,
            payRange.isHourly);
    }
}
